import {SC_User} from "../SC_User";
import {SC_CrewBase} from "./SC_CrewBase";
import {SC_Subcontractor} from "./SC_Subcontractor";
import {SC_EmployeeCrew} from "./SC_EmployeeCrew";
import {SC_CrewType} from "../enums/SC_CrewType";


export function SC_CrewfromAPI(jsonin: Record<string, any>, usersCache: SC_User[] = []): SC_CrewBase {
    let originator = SC_CrewType.fromAPI(jsonin[SC_CrewBase.inputKeys.crewType]);

    let out: SC_CrewBase;

    const number = originator.toAPI();

    switch (number) {
        case SC_CrewType.SUB:
            out = SC_Subcontractor.fromAPI(jsonin);
            break;
        case SC_CrewType.EMPLOYEE_BACKED:
            out = SC_EmployeeCrew.fromAPI(jsonin);
            break;
        default:
            out = new SC_CrewBase(SC_CrewBase.basicAPIStuff(jsonin));
            break;
    }

    if (usersCache)
        out.scavengeUsers(usersCache);

    return out;
}
